import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveChannel, selectGmlProjectionItems } from 'redux/channels';
import { Email24 } from '@carbon/icons-react';
import Utils from 'utilities/helper.util';
import { ActiveChannelDataType } from 'redux/channels/types';

export const FallbackActiveChannelComponent: React.FC<any> = () => {
  const gmlProjectionOptions: any = useSelector(selectGmlProjectionItems);
  const activeChannels: ActiveChannelDataType = useSelector(
    selectActiveChannel
  );
  const [requiredAttachments, setRequiredAttachments] = useState<
    string | undefined
  >('-');
  const [gmlProjection, setGmlProjection] = useState<string | undefined>('-');
  const [startedLiveAt, setStartedLiveAt] = useState<string | undefined>('-');
  const [referralEmail, setReferralEmail] = useState<string | undefined>('-');

  useEffect(() => {
    if (activeChannels && !Utils.isObjectEmpty(activeChannels)) {
      const legacyEmailConfiguration = activeChannels.LegacyEmailConfiguration;
      const startLiveDate = Utils.toLocalDateTimeFormat(
        activeChannels.startedLiveAt || activeChannels.updatedAt
      );

      startLiveDate && setStartedLiveAt(startLiveDate);
      if (legacyEmailConfiguration) {
        const attachments = [];
        legacyEmailConfiguration.isGifRequired && attachments.push('GIF');
        legacyEmailConfiguration.isGmlRequired &&
          attachments.push(legacyEmailConfiguration.gmlVersion);
        legacyEmailConfiguration.isXmlRequired && attachments.push('XML');
        legacyEmailConfiguration.isPdfRequired && attachments.push('PDF');
        setRequiredAttachments(
          attachments.length > 0 ? attachments.join(', ') : ''
        );
        const selectedGml = gmlProjectionOptions?.filter(
          (item: any) => item.code === legacyEmailConfiguration.gmlProjection
        );
        selectedGml && setGmlProjection(selectedGml[0]?.label);
        setReferralEmail(legacyEmailConfiguration.emailNormalEnquiries);
      }
    }
  }, [activeChannels, gmlProjectionOptions]);

  return (
    <>
      <div className="section__top">
        <Email24 />
        <div className="section__body">
          <h2 className="section__sub-heading">
            Your active referral channel is Legacy Fallback
          </h2>
          <p className="section__label">
            Legacy fallback is for organisations who are not yet ready to
            migrate to the Next Generation BYDA referral service.
            <br />
            Changes to your referral configuration are managed by the BYDA
            Helpdesk.
          </p>
        </div>
        <hr className="section__divider" />
      </div>

      <div className="section__referrals_email">
        <p className="section__label">Referrals are sent to</p>
        <p className="section__text">{referralEmail}</p>
        <hr className="section__divider" />
      </div>

      <div className="section__summary">
        <h4 className="section__sub-heading">Summary</h4>
        <div className="section__sub">
          <div className="section__label">Date activated</div>
          <p className="section__text">{startedLiveAt}</p>
        </div>
        <hr className="section__divider" />

        <div className="section__sub">
          <div className="section__label">Required attachments</div>
          <p className="section__text">{requiredAttachments}</p>
        </div>
        {gmlProjection && (
          <div className="section__sub">
            <div className="section__label">GML projection</div>
            <p className="section__text">{gmlProjection}</p>
          </div>
        )}
        <hr className="section__divider" />
      </div>
    </>
  );
};
export default FallbackActiveChannelComponent;
